import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import DCENJ from '../../Images/LSP.jpg';
import '../../css/Global.min.css';
import Competencias from '../../Images/Competencias.jpg';
import Modelo2 from '../../Images/Modelo2.jpg';
import Modalidades from '../../Images/Modalidad11.jpg';
import Biblioteca from '../../Images/Biblioteca.jpg';
import Titulacion from '../../Images/Titulacion.jpg';
import Informes from '../Informes';
import DIngreso from '../../Images/DIngreso.jpg';



class DEAA extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Materias: [],
            Semestres: [],
            Costos: [],
            Inscripcion: "",
            Colegiatura: "",
            Prope: "",
            Actual: '',
            Clave: "LSP",
            FechaInicio: "",
            FechaLimite: ""

        }


        var xhr = new XMLHttpRequest();
        var principal = this;
        var sobre = { Carrera: this.state.Clave };

        xhr.open("POST", "api/Web/GetPrograma", true);

        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
            if (xhr.status === 200) {
                var materias = JSON.parse(xhr.responseText).Table;
                var costos = JSON.parse(xhr.responseText).Table1;
                var fechaInicio = JSON.parse(xhr.responseText).Table2[0].FechaI;
                var fechaLimite = JSON.parse(xhr.responseText).Table2[0].FechaL;
                var prope = costos.find((item) => {
                    if (item.Prope === 1) {
                        return item.Formato
                    }
                });
                var insc = costos.find((item) => {
                    if (item.Prope === 0 && item.id_categoria === 0) {
                        return item.Formato
                    }
                });

                var col = costos.find((item) => {
                    if (item.Prope === 0 && item.id_categoria === 1) {
                        return item.Formato
                    }
                });

                var semestres = [];
                for (let i = 0; i < materias.length; i++) {
                    var buscar = semestres.find((item) => {
                        if (item == materias[i].semestre) {
                            return item;
                        }
                    });

                    if (buscar == null || buscar == undefined) {
                        semestres.push(materias[i].semestre);
                    };
                }
                if (prope === undefined) {
                    prope = { Formato: "" };
                };
                if (insc === undefined) {
                    insc = { Formato: "" };
                };
                if (col === undefined) {
                    col = { Formato: "" };
                };
                if (fechaInicio === undefined) {
                    fechaInicio = "";
                };
                if (fechaLimite === undefined) {
                    fechaLimite = "";
                };
                principal.setState({
                    Materias: materias,
                    Semestres: semestres,
                    Costos: costos,
                    Prope: prope.Formato,
                    Inscripcion: insc.Formato,
                    Colegiatura: col.Formato,
                    FechaInicio: fechaInicio,
                    FechaLimite: fechaLimite
                });

                //principal.iniciarWs(usuario + '|' + xhr.responseText + '|', usuario);
            } else {
                //******** Mensaje a Usuario correcto

                //alert(xhr.status);
                //alert(xhr.responseText);

            }


        };

        if (this.state.Materias.length === 0) {
            xhr.send(JSON.stringify(sobre));
        }
        //xhr.send(JSON.stringify(valores));

        this.materiasSemestre = this.materiasSemestre.bind(this);
        this.semestreTexto = this.semestreTexto.bind(this);
    }

    materiasSemestre(semestre) {
        var materias = [];
        for (let i = 0; i < this.state.Materias.length; i++) {
            if (this.state.Materias[i].semestre == semestre) {
                materias.push(this.state.Materias[i]);
            }
        }

        return materias;
    }

    semestreTexto(semestre) {
        var valor = "";
        switch (semestre) {

            case 1:
                valor = "Primer";
                break;
            case 2:
                valor = "Segundo";
                break;
            case 3:
                valor = "Tercer";
                break;
            case 4:
                valor = "Cuarto";
                break;
            case 5:
                valor = "Quinto";
                break;
            case 6:
                valor = "Sexto";
                break;
            case 7:
                valor = "Séptimo";
                break;
            case 8:
                valor = "Octavo";
                break;
            case 9:
                valor = "Noveno";
                break;
            case 10:
                valor = "D&eacute;cimo";
                break;
            case 11:
                valor = "D&eacute;cimo Primer";
                break;
            case 12:
                valor = "D&eacute;cimo Segundo";
                break;

        }
        return valor;
    }

    componentDidUpdate() {
        if (this.state.Actual != window.location.href) {
            this.state.Actual = window.location.href;
            this.props.reportarVisita(window.location.href, this.state.Clave, false)
        };
    }

    render() {
        return (
            <div>
                <div className="wrapper">
                    <MetaTags>
                        <title>Licenciatura en Sociología Política</title>
                        <meta name="description" content="Licenciatura en Sociología Política modalidad presencial en Irapuato" />
                        <meta name="keywords" content="Licenciatura, Sociología, Política, Presencial, Irapuato, Becas" />
                        <meta property="og:title" content="Licenciatura en Sociología Política" />
                        <meta property="og:description" content="Licenciatura en Sociología Política modalida presencial en Irapuato" />
                    </MetaTags>
                </div>
                <div className="content">
                    <div className="ImgenCentral2">
                        <img src={DCENJ} alt="Licenciatura en Sociología Política" />
                    </div>
                    <div className="FondoAlterno" style={{ maxWidth: "100%" }}>
                        <div className="Centrado" style={{ maxWidth: "45%", margin: "auto", padding: "50px" }}>
                            <p className="Parrafo1 Centrado" style={{ fontSize: "18pt" }} >
                                La <strong>Licenciatura en Sociolog&iacute;a Pol&iacute;tica</strong> esta diseñada para aquellos que buscan estudiar a los fen&oacute;menos pol&iacute;ticos y sus implicaciones sociales
                                            </p>
                        </div>
                    </div>
                    <div >
                        <div className="Separador ListaTabla DosColumnas" style={{ backgroundColor: "transparent" }}>
                            <br />
                            <ul>
                                <li>
                                    <div style={{ textAlign: "right" }}>
                                        <img src={Modalidades} alt='Modalidades' style={{ width: "90%" }} />
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <br />
                                        <h2 className="Negrita"><strong>Modalidad Presencial</strong></h2>
                                        <p className="Parrafo1 Justificado">
                                            <strong>Plantel Irapuato.</strong> Acuerdo SEG 013/2001 con fecha 7 de Mayo del 2001 con número de Expediente SEP 11-00157.
                                        </p>

                                    </div>
                                </li>
                            </ul>


                        </div>
                    </div>

                    
                    {(this.state.Materias.length === 0) ?
                        <div>NO</div>
                        :
                        <div className="CentrarH ListaTabla MarginAA FondoAlterno">

                            <br />
                            <h2 className="Negrita"><strong>Plan de estudios</strong></h2>

                            <div className="RequisitosCurriculares" style={{ paddingTop: "20px", textAlign: "left" }}>
                                <table>
                                    <tr>
                                        <td style={{ width: "150px" }}>
                                            <p><strong>Duraci&oacute;n: </strong></p>
                                        </td>
                                        <p>4 años (8 semestres)</p>
                                        <td></td>
                                    </tr>
                                    
                                </table>


                            </div>
                            <div>
                                <ul style={{ marginLeft: "65px" }}>
                                    {this.state.Semestres.map((itemS, indexS) => {
                                        return (
                                            <li style={{ width: "380px", minWidth: "380px" }}>
                                                <div className="MiniHistoria2 Justificar" style={{ border: "solid 1px gray" }}>
                                                    <table>
                                                        <tr>
                                                            <td style={{ fontSize: "14pt" }}>
                                                                <strong> {this.semestreTexto(itemS)} Semestre</strong>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td> &nbsp;
                                                        </td>

                                                        </tr>
                                                        {this.materiasSemestre(itemS).map((materia, index2) => {
                                                            return (
                                                                <tr>
                                                                    <td >

                                                                        <div className="Fuente2" style={{ textAlign: "left", fontWeight: "normal", marginBottom: "5px" }}>
                                                                            - {materia.materia_nombre}
                                                                        </div>
                                                                    </td>
                                                                </tr>


                                                            );
                                                        }
                                                        )}
                                                    </table>


                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>

                            </div>

                        </div>
                    }

                    <div className="Separador ListaTabla2 DosColumnas2 FondoBase" style={{ backgroundColor: "transparent" }}>
                        <ul style={{ width: "80%", margin: "auto" }}>

                            <li>
                                <div style={{ textAlign: "center", backgroundColor: "transparent" }}>
                                    <h2><strong>Documentos de ingreso</strong></h2>
                                    <br />
                                    <table className="Fuente3" style={{ fontSize: "14pt", width: "auto", margin: "auto", textAlign: "left" }}>
                                        <tr>
                                            <td>
                                                - Acta de Nacimiento
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                - CURP
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                - Certificado de secundaria
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                - Certificado de bachillerato
                                                </td>
                                        </tr>
                                    </table>
                                    <br />
                                    
                                </div>
                            </li>
                            {this.state.Costos.length > 0 ?

                                <li>
                                    <div className="Centado" style={{ textAlign: "center", backgroundColor: "transparent" }}>
                                        <h2><strong>Costos</strong></h2>
                                        <br />
                                        <table className="Fuente3" style={{ fontSize: "14pt", width: "auto", margin: "auto", textAlign: "left" }}>
                                            <tr style={{ height: "120px" }}>
                                                <td>
                                                    Inscripci&oacute;n
                                                </td>
                                                <td style={{ textAlign: "right", padding: "15px" }}>
                                                    <div>{this.state.Inscripcion}</div>
                                                </td>
                                                <td>
                                                    Pago al inicio de cada semestre
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Colegiatura mensual
                                                </td>
                                                <td style={{ textAlign: "right", padding: "15px" }}>
                                                    <div>{this.state.Colegiatura}</div>
                                                </td>
                                                <td>
                                                    6 cuotas por semestre, vence el d&iacute;a 17 de cada mes.
                                                </td>
                                            </tr>
                                        </table>

                                    </div>
                                </li>
                                :
                                null
                            }

                        </ul>


                    </div>
                    <Informes solicitarCarrera={() => { return this.state.Clave; }}
                        reportarVisita={this.props.reportarVisita}
                        getGuid={this.props.getGuid}
                        fechaInicio={() => { return this.state.FechaInicio }}
                        fechaLimite={() => { return this.state.FechaLimite }}
                    />
                </div>
            </div>
        );
    }
}

export default DEAA;


// WEBPACK FOOTER //
// ./src/components/Licenciaturas/LSP.js